import { Link, Span, TableBuilder } from "@tblabs/truffle";
import { Router } from "../Services/Router";
import { Page } from "./Page";
import { Box } from "../Components/Box";
import { OffersRepo } from "../Services/OffersRepo";
import { Panel } from "../Components/Panel";
import { Svg } from "../Components/Svg";


export class RecruitJobsListView extends Page
{
    constructor(
        private _offers: OffersRepo,
        private _router: Router)
    {
        super("Dostępne wakaty");

        this.Content(async () =>
        {
            await this._offers.Init();

            this.body.Append(
                new Box("Szukasz pracy lub dodatkowego zajęcia?\nDołącz do naszego zespołu!\nPoniżej znajduje się lista dostępnych wakatów.").FontSize(16).Color("#e4e4e4").TextAlignCenter().Italic().MarginTop(8).MarginBottom(32),
                new Panel("Dostępne wakaty", [
                new TableBuilder(_offers.Items)
                .AddColumn("Stanowisko", x => new Link(x.Title.value).OnClick(() => this._router.GoToOfferView(x)))
                .AddColumn("Rekrutacja", x => x.IsRecruitmentOpen.value ? "✅ Otwarta" : "🔒 Zamknięta")
                .Build(),
                ]),
                new Panel("Kontakt z nami", [
                    new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-phone-icon lucide-phone"><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"/></svg>`),
                    new Span("507-293-714"),
                    "\n",
                     new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-at-sign-icon lucide-at-sign"><circle cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8"/></svg>`),
                      new Span("specteam@specteam.pl"),
                     "\n",
                     new Svg(`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-tablet-smartphone-icon lucide-tablet-smartphone"><rect width="10" height="14" x="3" y="8" rx="2"/><path d="M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4"/><path d="M8 18h.01"/></svg>`), new Link("www.specTeam.pl", "https://www.specTeam.pl").Color("#e4e4e4"),
                ]),
            )
        });
    }
}
